import {
  ID_ADVANTAGES_ATTRIBUTE,
  ID_ANTI_FOG_MIRROR_ATTRIBUTE,
  ID_ARTICLE_ATTRIBUTE,
  ID_BACKLIGHT_ATTRIBUTE,
  ID_BACKLIGHT_TYPE_ATTRIBUTE,
  ID_BODY_COLOR_ATTRIBUTE,
  ID_BODY_MATERIAL_ATTRIBUTE,
  ID_COLOR_ATTRIBUTE,
  ID_DEPTH_ATTRIBUTE,
  ID_FACADE_MATERIAL_ATTRIBUTE,
  ID_HEIGHT_ATTRIBUTE,
  ID_MIRROR_SHAPE_ATTRIBUTE,
  ID_PRODUCT_IMAGE_ATTRIBUTE,
  ID_REMAINDER_ATTRIBUTE,
  ID_SEO_NAME_ATTRIBUTE,
  ID_STORAGE_SYSTEM_ATTRIBUTE,
  ID_SUBCATEGORY_ATTRIBUTE,
  ID_SWITCH_TYPE_ATTRIBUTE,
  ID_TYPE_PRODUCT_ATTRIBUTE,
  ID_WIDTH_ATTRIBUTE
} from '@shared/constants/keys';
import { ProductCardType, ProductRatingsType, ProductsType } from '@shared/types/product';

export const getProductCardData = (data: ProductsType, ratings?: ProductRatingsType): ProductCardType[] => {
  if (!data) return [];
  const result: ProductCardType[] = [];

  Object.keys(data).forEach((id) => {
    const value = data[id];

    const productInfo = {
      id,
      name: value.name,
      seoName: value.props?.[ID_SEO_NAME_ATTRIBUTE]?.values?.[0].value,
      price: value.retailPrice,
      url: value.translitName,
      selected: value.selected,
      images: value.props?.[ID_PRODUCT_IMAGE_ATTRIBUTE]?.values?.toSorted((a, b) => a.sort - b.sort),
      width: value.props?.[ID_WIDTH_ATTRIBUTE]?.values?.[0],
      depth: value.props?.[ID_DEPTH_ATTRIBUTE]?.values?.[0],
      height: value.props?.[ID_HEIGHT_ATTRIBUTE]?.values?.[0],
      color: value.props?.[ID_COLOR_ATTRIBUTE]?.values?.[0],
      bodyMaterial: value.props?.[ID_BODY_MATERIAL_ATTRIBUTE]?.values?.[0],
      facadeMaterial: value.props?.[ID_FACADE_MATERIAL_ATTRIBUTE]?.values?.[0],
      category: value.props?.[ID_TYPE_PRODUCT_ATTRIBUTE]?.values?.[0]?.value || 'без категории',
      subCategory: value.props?.[ID_SUBCATEGORY_ATTRIBUTE]?.values?.[0]?.value || 'без подкатегории категории',
      article: value.props?.[ID_ARTICLE_ATTRIBUTE]?.values?.[0]?.value,
      quantity: value.quantity,
      remainder: value.props?.[ID_REMAINDER_ATTRIBUTE]?.values[0]?.value,
      rating: ratings?.[id],
      advantages: value.props?.[ID_ADVANTAGES_ATTRIBUTE]?.values?.[0].value,
      backlightType: value.props?.[ID_BACKLIGHT_TYPE_ATTRIBUTE]?.values?.[0]?.value,
      switchType: value.props?.[ID_SWITCH_TYPE_ATTRIBUTE]?.values?.[0]?.value,
      mirrorShape: value.props?.[ID_MIRROR_SHAPE_ATTRIBUTE]?.values?.[0]?.value,
      antifogMirror: value.props?.[ID_ANTI_FOG_MIRROR_ATTRIBUTE]?.values?.[0]?.value,
      bodyColor: value.props?.[ID_BODY_COLOR_ATTRIBUTE]?.values?.[0]?.value,
      storageSystem: value.props?.[ID_STORAGE_SYSTEM_ATTRIBUTE]?.values?.[0]?.value,
      backlight: value.props?.[ID_BACKLIGHT_ATTRIBUTE]?.values?.[0]?.value
    };
    result.push(productInfo);
  });

  return result;
};
